export const $CheckoutCustomerDetailsFormModuleName =
    "checkoutCustomerDetailsForm";

export type TCheckoutCustomerDetailsFormState = {
    deliveryAddressId: string | null;
    paymentAddressId: string | null;
    isLoading: boolean;
};
